const MIME_TYPE_MAP: { [key: string]: string } = {
  pdf: 'application/pdf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  png: 'image/png',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  csv: 'text/csv',
};

export const getMimeByExt = (fileExtension: string) =>
  MIME_TYPE_MAP[fileExtension];

export const toBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export const toByteArray = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export const base64WithoutHeader = async (file?: File) => {
  let result = '';
  if (file) {
    const string64 = (await toBase64(file)) as string;
    result = string64?.split('base64,')[1];
  }
  return result;
};

export const base64ToUint8Array = (base64Data: string): Uint8Array => {
  return Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
};
